import { render, staticRenderFns } from "./DialogWrap.vue?vue&type=template&id=15d081e0&scoped=true&"
import script from "./DialogWrap.vue?vue&type=script&lang=js&"
export * from "./DialogWrap.vue?vue&type=script&lang=js&"
import style0 from "./DialogWrap.vue?vue&type=style&index=0&id=15d081e0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d081e0",
  null
  
)

export default component.exports